<template>
  <v-app id="login">
    <v-container fluid fill-height class="pa-0">
      <!--<v-layout align-center justify-center>-->
      <v-layout row wrap>
        <v-flex sm6 md8 lg8>
          <div id="divider"></div>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
          lg4
          style="display: flex; align-items: center; flex-direction: column"
        >
          <div class="forgotPassword">
            <h3 class="mt-7 mb-3 text-h4">Recuperar senha</h3>
            <v-form>
              <v-text-field
                append-icon="person"
                name="email"
                label="Email"
                type="text"
                v-model="model.email"
                v-validate="'required|email'"
                :v-errors="errors"
                :error-messages="errors.collect('email')"
                data-vv-name="email"
                required
                outlined
                dense
                hide-details="auto"
                v-on:keyup.13="sendResetEmail"
              >
              </v-text-field>
            </v-form>
            <v-btn
              color="primary"
              rounded
              @click="sendResetEmail"
              :loading="logging"
              >Enviar</v-btn
            >
            <v-btn small text :to="{ name: 'login' }">Voltar para login</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { sendResetEmail } from "../../services/auth.service";

export default {
  data: () => ({
    logging: false,
    model: {
      email: "",
    },
  }),

  methods: {
    async sendResetEmail() {
      if (await this.formHasErrors()) return;
      this.logging = true;
      sendResetEmail(this.model)
        .then((response) => {
          // const { status } = response.data
          // console.log(response)
          window.getApp.sendSnackMessage(
            "Enviamos um link para definição de outra senha. Verifique seu email ;)",
          );
          this.logging = false;
        })
        .catch((ex) => {
          console.error(ex);
          this.logging = false;
          window.getApp.sendSnackMessage(
            "Email não foi encontrado na base de dados",
            "error",
          );
        });
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 0%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
#divider {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  background-image: url("/img/login/lucas-muita-aprovacao.jpg");
  background-size: cover;
  overflow: hidden;
}
.forgotPassword {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  width: 100%;
  max-width: 330px;
}
</style>
